import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { KnowledgeGlossaryEntry } from '../../constants/knowledgeGlossary';
import './KnowledgePointModal.css';

interface Props {
    entry: KnowledgeGlossaryEntry;
    onClose: () => void;
}

const KnowledgePointModal: React.FC<Props> = ({ entry, onClose }) => {
    const { t } = useTranslation('learningReport');

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div
            className="kp-modal-backdrop"
            role="dialog"
            aria-modal="true"
            aria-labelledby="kp-modal-title"
            onClick={onClose}
        >
            <div
                className="kp-modal-card"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="kp-modal-close"
                    aria-label={t('closeModal')}
                    onClick={onClose}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <h3 id="kp-modal-title" className="kp-modal-title">
                    {entry.title}
                </h3>
                <p className="kp-modal-summary">{entry.summary}</p>
                <div className="kp-modal-actions">
                    <a
                        href={entry.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="kp-modal-learn-more"
                    >
                        {t('learnMore')}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M7 17L17 7" />
                            <polyline points="7 7 17 7 17 17" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default KnowledgePointModal;
